import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTrackEventMutation } from 'src/common/slices/analytics';
import { BookNowModal } from 'src/features/business/landing-page/components';
import { StyledButton, StyledChatWithSales, StyledContainer, StyledCTAButtons, StyledCTAWrapper, StyledDescription, StyledHeading, StyledHeroContent, StyledNewTag, StyledNewTagContent, StyledNewTagText, StyledTag } from './hero.styles';
export const Hero = () => {
  const navigate = useNavigate();
  const [isBookNowOpen, setIsBookNowOpen] = useState(false);
  const [trackEvent] = useTrackEventMutation();
  const handleBuyNow = () => {
    trackEvent({
      event: 'click-buy-now-b2b'
    });
    navigate('/business/checkout?ref=b2b-home-page ');
  };
  const handleBookDemo = () => {
    trackEvent({
      event: 'click-book-demo'
    });
    setIsBookNowOpen(true);
  };
  const handleChatWithSales = () => {
    trackEvent({
      event: 'click-chat-sales'
    });
    if (window.Intercom) {
      window.Intercom('showNewMessage');
    }
  };
  return <>
      <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="hero.tsx">
        <StyledHeroContent data-sentry-element="StyledHeroContent" data-sentry-source-file="hero.tsx">
          <StyledTag data-sentry-element="StyledTag" data-sentry-source-file="hero.tsx">
            <StyledNewTag data-sentry-element="StyledNewTag" data-sentry-source-file="hero.tsx">
              <StyledNewTagText data-sentry-element="StyledNewTagText" data-sentry-source-file="hero.tsx">NEW</StyledNewTagText>
            </StyledNewTag>
            <StyledNewTagContent data-sentry-element="StyledNewTagContent" data-sentry-source-file="hero.tsx">
              <span>TryHackMe for Business</span>
            </StyledNewTagContent>
          </StyledTag>

          <StyledHeading data-sentry-element="StyledHeading" data-sentry-source-file="hero.tsx">Develop teams that stop breaches faster</StyledHeading>

          <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="hero.tsx">
            Hands-on, hyper-realistic cyber training for SOC & IR teams - build confidence, close gaps, and reduce
            breach impact
          </StyledDescription>

          <StyledCTAWrapper data-sentry-element="StyledCTAWrapper" data-sentry-source-file="hero.tsx">
            <StyledCTAButtons data-sentry-element="StyledCTAButtons" data-sentry-source-file="hero.tsx">
              <StyledButton variant="primary" onClick={handleBookDemo} data-sentry-element="StyledButton" data-sentry-source-file="hero.tsx">
                Try for FREE
              </StyledButton>
              <StyledButton variant="secondary" onClick={handleBuyNow} data-sentry-element="StyledButton" data-sentry-source-file="hero.tsx">
                Buy now
              </StyledButton>
            </StyledCTAButtons>
            <StyledChatWithSales onClick={handleChatWithSales} data-sentry-element="StyledChatWithSales" data-sentry-source-file="hero.tsx">Chat with sales</StyledChatWithSales>
          </StyledCTAWrapper>
        </StyledHeroContent>
      </StyledContainer>

      <BookNowModal open={isBookNowOpen} onOpenChange={setIsBookNowOpen} title="Try for FREE" description="Enter your details to book a demo. We'll be in touch to schedule a time." data-sentry-element="BookNowModal" data-sentry-source-file="hero.tsx" />
    </>;
};